import React from 'react';

import { Fieldset } from "components/layout";
import { SeoExtLinkTemplatePageList } from 'components/blocks/SeoExtLinkTemplatePage';


export default ({ match }) => {
  const seoExtDomainId = match.params.seoExtDomainId;

  return (
    <Fieldset>
      <SeoExtLinkTemplatePageList activeFilter={{ ext_link__ext_domain: seoExtDomainId }}/>
    </Fieldset>
  )
};
